<template>
  <div id="WithdrawEnrolmentReport">
    <div class="container">
      <div class="row header mb-5">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">WITHDRAW AND ENROLMENT REPORT</h3>
        </div>
      </div>

      <div id="Filter" class="container p-4">
        <K2Filter :filter-list="filterList" :dateType="dateType" @onFilter="handleFilter" @onFilterChange="onFilterChange" />
      </div>
      <div class="datatable-form__input form-group flex-1 text-left">
        <label></label>
        <b-button @click="exportCSV()" :disabled="Data.length == 0">Export</b-button>
      </div>
      <div class="datatable-form__header atr-header-wrap mb-4">
        <el-table :data="Data" v-if="this.filterList[2].selected === this.reportType[1].label">
          <el-table-column prop="Index_No" label="Index No" width="240" />
          <el-table-column prop="Full_name" label="Full_name" width="240">
            <template #default="scope">
              {{ scope.row.Full_name + ' ' + scope.row.Last_name }}
            </template>
          </el-table-column>

          <el-table-column prop="Comm_Date" label="Comm Date" width="240" />
          <el-table-column prop="School_Name" label="SchoolName" width="240" />
          <el-table-column prop="Create_Date" label="Created On" width="240" />
        </el-table>
        <el-table :data="Data" v-else>
          <el-table-column prop="Index_No" label="Index No" width="240" />
          <el-table-column prop="Full_name" label="Full_name" width="240">
            <template #default="scope">
              {{ scope.row.Full_name + ' ' + scope.row.Last_name }}
            </template>
          </el-table-column>

          <el-table-column prop="WithdrawDate" label="WithdrawDate" width="240" />
          <el-table-column prop="School_Name" label="SchoolName" width="240" />
          <el-table-column prop="Create_Date" label="Created On" width="240" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import K2Button from '@/uiComponents/k2Button/k2Button'
import K2Heading from '@/uiComponents/k2Heading/k2Heading'
import K2Row from '@/uiComponents/k2Row/k2Row'
import K2Filter from '@/uiComponents/k2Filter/k2Filter'
import VueHtml2pdf from 'vue-html2pdf'
import ReportContent from '@/pages/AttendanceReports/ReportContent'
import Cookies from 'js-cookie'
import uiVariable from '@/config/uiVariable'
import { lang } from '@/locale'
import DataSource from '@/data/datasource'
import Export_CSV from '@/components/Export_CSV'

export default {
  name: 'WithdrawEnrolmentReport',
  components: { K2Button, K2Heading, K2Row, K2Filter, VueHtml2pdf, ReportContent },
  async created() {
    this.schID = Cookies.get('schoolSession')
    await this.getSchools()
    this.filterList[2].optionList = this.reportType
  },
  data() {
    return {
      uiVariable: uiVariable,
      dateRange: null,
      dateType: 'daterange',
      fromDate: '',
      toDate: '',
      selectedSchool: '',
      reportType: [
        {
          id: 'Withdraw',
          label: 'Withdraw',
          type: 'reportType',
        },
        {
          id: 'Enrolment',
          label: 'Enrolment',
          type: 'reportType',
        },
      ],

      studentTypes: [],

      filterList: [
        {
          label: 'Schools',
          placeholder: 'Filter by Schools',
          optionList: [],
        },
        {
          label: 'Date',
          placeholder: 'Filter by date',
          selected: [],
        },
        {
          label: 'Report Type',
          placeholder: 'Report Type',
          optionList: [],
        },
      ],
      Data: [],
    }
  },
  methods: {
    lang,
    handleFilter(type) {
      if (this.filterList[0].selected !== undefined) {
        this.selectedSchool = this.filterList[0].selected.toString()
      }
      if (this.filterList[1].selected !== undefined) {
        this.dateRange = this.filterList[1].selected.toString()
        this.splitDates()
      }
      if (this.filterList[2].selected !== undefined) {
        // this.dateRange = (this.filterList[2].selected).toString();
        // this.splitDates();
      }
      this.loadReport()
    },

    splitDates() {
      let dateSplit = this.dateRange.split(',')
      this.fromDate = dateSplit[0]
      this.toDate = dateSplit[1]
    },

    onFilterChange(value) {
      if (value) {
        this.getClass(value)
      }
    },

    async getSchools() {
      const response = await DataSource.shared.getSchoolDropdownList('UTY201300000061')
      if (response) {
        response.Table.forEach(d => {
          d.id = d.SchoolID
          d.label = d.SchoolName
          d.type = 'school'
        })
      }
      this.filterList[0].optionList = response.Table
    },

    async loadReport() {
      this.$vs.loading()

      if (!this.filterList[2].selected) {
      } else {
        try {
          if (this.filterList[2].selected === this.reportType[0].label) {
            const response = await DataSource.shared.GetWithdrawReport(this.fromDate, this.toDate, this.selectedSchool)
            if (response) {
              this.Data = response
              this.Data.forEach(m => {
                let newSCRS_To_Date = new Date(m.WithdrawDate)
                const options = { year: 'numeric', month: 'long', day: 'numeric' }
                m.WithdrawDate = newSCRS_To_Date.toLocaleDateString('en', options)

                let newCreated_On = new Date(m.Create_Date)
                m.Create_Date = newCreated_On.toLocaleDateString('en', options)
              })
            }
          } else if (this.filterList[2].selected === this.reportType[1].label) {
            const response = await DataSource.shared.GetEnrolReport(this.fromDate, this.toDate, this.selectedSchool)
            if (response) {
              this.Data = response
              this.Data.forEach(m => {
                let newSCRS_To_Date = new Date(m.Comm_Date)
                const options = { year: 'numeric', month: 'long', day: 'numeric' }
                m.Comm_Date = newSCRS_To_Date.toLocaleDateString('en', options)

                let newCreated_On = new Date(m.Create_Date)
                m.Create_Date = newCreated_On.toLocaleDateString('en', options)
              })
            }
          }
        } catch (e) {
          this.results = e
          console.log(e)
        }
      }

      this.$vs.loading.close()
    },

    exportCSV() {
      let finalExportList = []

      if (this.Data.length > 0) {
        if (this.filterList[2].selected === this.reportType[0].label) {
          this.Data.forEach((m, index) => {
            let tempRow = {
              Index_No: m.Index_No,
              Full_name: m.Full_name + ' ' + m.Last_name,
              WithdrawDate: m.WithdrawDate,
              School_Name: m.School_Name,
              Create_Date: m.Create_Date,
            }
            finalExportList.push(tempRow)
          })
        } else {
          this.Data.forEach((m, index) => {
            let tempRow = {
              Index_No: m.Index_No,
              Full_name: m.Full_name + ' ' + m.Last_name,
              Comm_Date: m.Comm_Date,
              School_Name: m.School_Name,
              Create_Date: m.Create_Date,
            }
            finalExportList.push(tempRow)
          })
        }
      }

      Export_CSV.CsvExport(finalExportList, '', '', this.filterList[2].selected + 'Report - (' + this.fromDate + ')-(' + this.toDate + ')')
    },
  },
}
</script>

<style scoped></style>
